<template>
  <header class="bg-white py-3 px-6 sticky top-0 z-50 shadow-sm">
    <div class="max-w-7xl mx-auto flex items-center justify-between">
      <div class="flex items-center gap-2">
        <i class="fa-solid fa-book-open text-primary text-2xl"></i>
        <h1 class="text-xl font-bold">简创小说</h1>
      </div>

      <nav class="hidden md:flex items-center gap-8">
        <a href="#" class="nav-item py-2 px-1 border-b-2 border-transparent transition-colors" :class="{ 'nav-active': currentSection === 'short-novel' }" @click.prevent="$emit('nav', 'short-novel')">短篇小说创作</a>
        <!-- <a href="#" class="nav-item py-2 px-1 border-b-2 border-transparent transition-colors" :class="{ 'nav-active': currentSection === 'long-novel' }" @click.prevent="$emit('nav', 'long-novel')">长篇小说创作</a> -->
        <a href="#" class="nav-item py-2 px-1 border-b-2 border-transparent transition-colors" :class="{ 'nav-active': currentSection === 'coreIdea' }" @click.prevent="$emit('nav', 'coreIdea')">小说核心梗提取</a>
        <a href="#" class="nav-item py-2 px-1 border-b-2 border-transparent transition-colors" :class="{ 'nav-active': currentSection === 'outline' }" @click.prevent="$emit('nav', 'outline')">小说大纲提取</a>
        <a href="#" class="nav-item py-2 px-1 border-b-2 border-transparent transition-colors" :class="{ 'nav-active': currentSection === 'cover' }" @click.prevent="$emit('nav', 'cover')">小说封面生成</a>
        <a href="#" class="nav-item py-2 px-1 border-b-2 border-transparent transition-colors" :class="{ 'nav-active': currentSection === 'vip-recharge' }" @click.prevent="$emit('nav', 'vip-recharge')">会员充值</a>
      </nav>

      <div class="flex items-center gap-4">
        <div class="relative user-dropdown hidden md:block">
          <span v-if="!isLoggedIn" class="mr-3 text-red-500 font-medium">注册即送100创作点</span>
          <button v-if="!isLoggedIn" class="bg-primary text-white px-4 py-2 rounded-md btn-hover" @click="$emit('login')">登录/注册</button>

          <template v-else>
            <button
              id="user-avatar-btn"
              type="button"
              class="w-10 h-10 rounded-full flex items-center justify-center text-white cursor-pointer relative border border-gray-200 shrink-0"
              :class="showAvatarImg ? '' : 'bg-primary'"
              @click="userMenuOpen = !userMenuOpen"
            >
              <span
                v-if="showAvatarImg"
                class="absolute inset-0 z-0 rounded-full overflow-hidden pointer-events-none"
              >
                <img
                  :src="avatarDisplaySrc"
                  class="block w-full h-full object-cover"
                  alt=""
                  referrerpolicy="no-referrer"
                  @error="onAvatarLoadError"
                >
              </span>
              <i v-else class="fa-solid fa-user relative z-[1]"></i>
              <div
                id="creative-points"
                class="absolute -bottom-9 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-blue-50 to-indigo-50 py-2 px-3 rounded-lg text-sm text-gray-700 shadow-lg border border-blue-100 flex items-center gap-1.5 transition-all duration-200 whitespace-nowrap z-20"
              >
                <svg class="w-4 h-4 text-blue-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                </svg>
                <span>创作点余额：{{ balancePoints }}</span>
              </div>
            </button>
            <div v-show="userMenuOpen" class="user-menu-dropdown absolute top-16 bg-white rounded shadow-lg py-2 z-50 border border-gray-200" style="right: -4.0rem;width: 10.5rem;">
              <div class="p-3 border-b border-gray-100">
                <div class="flex items-center gap-2">
                  <div
                    class="w-8 h-8 rounded-full flex items-center justify-center text-white overflow-hidden border border-gray-200 shrink-0 relative"
                    :class="showAvatarImg ? '' : 'bg-primary'"
                  >
                    <img
                      v-if="showAvatarImg"
                      :src="avatarDisplaySrc"
                      class="absolute inset-0 w-full h-full object-cover pointer-events-none"
                      alt=""
                      referrerpolicy="no-referrer"
                      @error="onAvatarLoadError"
                    >
                    <i v-else class="fa-solid fa-user text-sm relative z-[1]"></i>
                  </div>
                  <span>{{ displayNickname }}</span>
                </div>
              </div>
              <ul class="py-2">
                <li><a href="#" class="block px-4 py-2 hover:bg-gray-50" @click.prevent="$emit('nav', 'profile'); userMenuOpen = false">个人中心</a></li>
                <li><a href="#" class="block px-4 py-2 hover:bg-gray-50" @click.prevent="$emit('nav', 'my-novels'); userMenuOpen = false">我的小说</a></li>
                <li><a href="#" class="block px-4 py-2 hover:bg-gray-50" @click.prevent="$emit('nav', 'consume-record'); userMenuOpen = false">消费记录</a></li>
                <li><a href="#" class="block px-4 py-2 hover:bg-gray-50 text-red-500" @click.prevent="$emit('logout'); userMenuOpen = false">退出登录</a></li>
              </ul>
            </div>
          </template>
        </div>

        <button class="md:hidden text-textMain text-2xl" @click="mobileOpen = !mobileOpen">
          <i class="fa-solid fa-bars"></i>
        </button>
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div v-show="mobileOpen" class="md:hidden absolute top-full left-0 w-full bg-white shadow-lg border-t border-gray-100">
      <div class="flex flex-col p-4 gap-4">
        <a href="#" class="nav-item py-2 px-4 rounded-md hover:bg-gray-50" :class="{ 'nav-active': currentSection === 'short-novel' }" @click.prevent="go('short-novel')">短篇小说创作</a>
        <!-- <a href="#" class="nav-item py-2 px-4 rounded-md hover:bg-gray-50" :class="{ 'nav-active': currentSection === 'long-novel' }" @click.prevent="go('long-novel')">长篇小说创作</a> -->
        <a href="#" class="nav-item py-2 px-4 rounded-md hover:bg-gray-50" :class="{ 'nav-active': currentSection === 'coreIdea' }" @click.prevent="go('coreIdea')">小说核心梗提取</a>
        <a href="#" class="nav-item py-2 px-4 rounded-md hover:bg-gray-50" :class="{ 'nav-active': currentSection === 'outline' }" @click.prevent="go('outline')">小说大纲提取</a>
        <a href="#" class="nav-item py-2 px-4 rounded-md hover:bg-gray-50" :class="{ 'nav-active': currentSection === 'cover' }" @click.prevent="go('cover')">小说封面生成</a>
        <a href="#" class="nav-item py-2 px-4 rounded-md hover:bg-gray-50" :class="{ 'nav-active': currentSection === 'vip-recharge' }" @click.prevent="go('vip-recharge')">会员充值</a>
        <div class="border-t border-gray-100 pt-4 mt-2">
          <button v-if="!isLoggedIn" class="w-full bg-primary text-white py-2 rounded-md btn-hover" @click="$emit('login'); mobileOpen = false">登录/注册</button>
          <div v-else class="flex flex-col gap-2">
            <div class="flex items-center gap-3 mb-2 px-4">
              <div
                class="w-10 h-10 rounded-full flex items-center justify-center text-white overflow-hidden border border-gray-200 shrink-0 relative"
                :class="showAvatarImg ? '' : 'bg-primary'"
              >
                <img
                  v-if="showAvatarImg"
                  :src="avatarDisplaySrc"
                  class="absolute inset-0 w-full h-full object-cover pointer-events-none"
                  alt=""
                  referrerpolicy="no-referrer"
                  @error="onAvatarLoadError"
                >
                <i v-else class="fa-solid fa-user relative z-[1]"></i>
              </div>
              <div>
                <div class="font-medium">{{ displayNickname }}</div>
                <div class="text-sm text-primary">创作点：{{ balancePoints }}</div>
              </div>
            </div>
            <a href="#" class="block py-2 px-4 hover:bg-gray-50 rounded-md" @click.prevent="go('profile')">个人中心</a>
            <a href="#" class="block py-2 px-4 hover:bg-gray-50 rounded-md" @click.prevent="go('my-novels')">我的小说</a>
            <a href="#" class="block py-2 px-4 hover:bg-gray-50 rounded-md" @click.prevent="go('consume-record')">消费记录</a>
            <a href="#" class="block py-2 px-4 hover:bg-gray-50 rounded-md text-red-500" @click.prevent="$emit('logout'); mobileOpen = false">退出登录</a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  props: {
    currentSection: { type: String, default: 'short-novel' },
    isLoggedIn: { type: Boolean, default: false },
    nickname: { type: String, default: '' },
    /** 用户头像图片地址：http(s)、//、站内路径 / 或 data:image */
    avatar: { type: String, default: '' },
    balancePoints: { type: [Number, String], default: 0 }
  },
  computed: {
    displayNickname () {
      var n = (this.nickname || '').trim()
      return n || '用户'
    },
    /** 有可展示的地址字符串（加载失败会退回默认图标） */
    hasUsableAvatarSrc () {
      return this.isUsableAvatarSrc(this.avatar)
    },
    avatarDisplaySrc () {
      if (!this.hasUsableAvatarSrc) return ''
      return (this.avatar || '').trim()
    },
    showAvatarImg () {
      return this.hasUsableAvatarSrc && !this.avatarLoadError
    }
  },
  watch: {
    avatar () {
      this.avatarLoadError = false
    }
  },
  data () {
    return {
      userMenuOpen: false,
      mobileOpen: false,
      avatarLoadError: false
    }
  },
  methods: {
    isUsableAvatarSrc (value) {
      var s = value != null ? String(value).trim() : ''
      if (!s) return false
      var lower = s.toLowerCase()
      if (lower.indexOf('http://') === 0 || lower.indexOf('https://') === 0) return true
      if (lower.indexOf('//') === 0) return true
      if (s.charAt(0) === '/') return true
      if (lower.indexOf('data:image/') === 0) return true
      return false
    },
    onAvatarLoadError () {
      this.avatarLoadError = true
    },
    go (section) {
      this.$emit('nav', section)
      this.mobileOpen = false
    }
  }
}
</script>
